// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
export var emptyCheck = {
  extrinsic: {},
  payload: {}
};